import { ComponentType } from "react";
import classNames from "classnames";
import "./style.css";

interface Props {
  buttonClass: string;
  imageClass: string;
  textClass: string;
  logo: ComponentType<React.SVGProps<SVGSVGElement>>;
  onClick: () => void;
  children: React.ReactNode;
}

export default function AuthButton(props: Props) {
  return (
    <button
      onClick={props.onClick}
      className={classNames(props.buttonClass, "social-auth-button")}
    >
      <props.logo className={classNames("social-auth-button-logo", props.imageClass)} />
      <span className={classNames("social-auth-button-text", props.textClass)}>
        {props.children}
      </span>
    </button>
  );
}
